import {Drawer, DrawerProps, ScrollArea} from '@mantine/core';
import {RecordForm} from '../forms/RecordForm';
import {Subscription} from '../types';

export const FormDrawer = (
    {
        record,
        handleSubmit,
        opened,
        onClose,
        ...rest
    }: DrawerProps & {
        record: Subscription,
        handleSubmit: (values: Subscription) => void
    }) => {

    const title = record?.id ? 'Edit Subscription' : 'Add Subscription';

    const handleFormSubmit = async (values: Subscription) => {
        await handleSubmit(values);
        onClose();
    };

    return (
        <Drawer
            transitionProps={{
                transition: 'slide-left',
                duration: 750,
                timingFunction: 'ease'
            }}
            position="right"
            offset={10}
            opened={opened}
            onClose={onClose}
            title={title}
            padding="xl"
            size="xl"
            scrollAreaComponent={ScrollArea.Autosize}
            {...rest}
        >
            <RecordForm
                record={record}
                handleSubmit={handleFormSubmit}
                handleCancel={onClose}
            />
        </Drawer>
    );
};
